import React from "react";
import { Box, Switch, TextField, MenuItem, Select } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useData, useDataFunctions } from "contexts/Data";
import { LoadingBox } from "../Loading";

import DumbNote from "../DumbNote";

export default function OperationsManager() {
  const data = useData();
  const dataFunctions = useDataFunctions();

  const [loading, setLoading] = React.useState(true);
  const [changes, setChanges] = React.useState([]);
  const [problems, setProblems] = React.useState([]);

  React.useEffect(() => {
    dataFunctions
      .getOpsStatus()
      .then((result) => {
        // console.log(result);
        setChanges(result.changes || []);
        setProblems(result.problems || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    // <Box sx={{ height: 300, width: '100%' }}>
    <Box sx={{ height: "100%", width: "100%" }}>
      <Box sx={{ height: "30%", width: "100%" }}>
        <h2>Operations Note</h2>
        <DumbNote noteType="operations_status_note" />
      </Box>
      <LoadingBox loading={loading} message={"Loading Changes"} sx={{ height: "30%", width: "100%" }}>
        <h2>Changes</h2>
        <DataGrid
          rows={changes}
          columns={[
            { field: "number", headerName: "Number", width: 150 },
            {
              field: "short_description",
              headerName: "Short Description",
              width: 300,
            },
            { field: "description", headerName: "Description", width: 300 },
            { field: "state", headerName: "State", width: 150 },
            {
              field: "scheduled_start",
              headerName: "Scheduled Start",
              width: 200,
            },
            { field: "scheduled_end", headerName: "Scheduled End", width: 200 },
            { field: "assigned_to", headerName: "Assigned To", width: 200 },
          ]}
          getRowId={(row) => row.number}
          components={{ Toolbar: GridToolbar }}
        />
      </LoadingBox>
      <LoadingBox loading={loading} message={"Loading Problems"} sx={{ height: "30%", width: "100%" }}>
        <h2>Problems</h2>
        <DataGrid
          rows={problems}
          columns={[
            { field: "number", headerName: "Number", width: 150 },
            {
              field: "short_description",
              headerName: "Short Description",
              width: 300,
            },
            { field: "description", headerName: "Description", width: 300 },
            { field: "state", headerName: "State", width: 150 },
            { field: "opened_at", headerName: "Opened At", width: 200 },
            { field: "assigned_to", headerName: "Assigned To", width: 200 },
          ]}
          getRowId={(row) => row.number}
          components={{ Toolbar: GridToolbar }}
        />
      </LoadingBox>
    </Box>
  );
}
